import { defineStore } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';

export const useCategoriesStore = defineStore('categories', {
    state: () => ({
        isCategoriesCardCollapsed: false,

        all: [
            {
                icon: 'mdi-truck-fast-outline',
                title: 'Encomendas',
                url: null,
                active: false,
                expanded: false,
                all_subcategories: [
                    { title: 'Normal', url: '/orders/normal', active: false, mobileonly:false,permission: 'View normal order' },
                    { title: 'Código de Barras', url: '/orders/normal?eanReader=true', active: false,mobileonly:true, permission: 'View normal order' },
                    { title: 'Affinity', url: '/orders/affinity', active: false, mobileonly:false,permission: 'View affinity order' },
                    { title: 'Express (Favoritos)', url: '/orders/express', active: false, mobileonly:false,permission: 'View express order' },
                    { title: 'Histórico', url: '/orders/history', active: false, mobileonly:false,permission: 'View order history' },
                    { title: 'Zero - Por Pagar', url: '/orders/awaiting-payment', active: false, mobileonly:false,permission: 'View orders awaiting payment' },
                    { title: 'Carrinhos Pendentes', url: '/orders/pending-carts', active: false,mobileonly:false,permission: 'View pending carts' },
                    { title: 'Produtos Pendentes', url: '/orders/pending-products', active: false,mobileonly:false, permission: 'View pending products' },
                ],
            },
            {
                icon: 'mdi-package-variant-closed',
                title: 'Produtos',
                url: null,
                expanded: false,
                active: false,
                all_subcategories: [
                    {
                        title: 'Simposium Veterinário',
                        url: '/products/simposium',
                        active: false,
                        mobileonly:false,
                        permission: 'View simposium',
                    },
                    {
                        title: 'Pedido de Tabela de Preços',
                        url: null,
                        active: false,
                        mobileonly:false,
                        permission: 'View price table requests',
                        isDialog: true,
                    },
                ],
            },
            {
                icon: 'mdi-sale',
                title: 'Campanhas',
                url: null,
                expanded: false,
                active: false,
                all_subcategories: [
                    {
                        title: 'Detalhes',
                        url: '/campaigns/simple-campaigns',
                        active: false,
                        mobileonly:false,
                        permission: 'View campaigns',
                    },
                    {
                        title: 'Informativo',
                        url: null,
                        active: false,
                        permission: 'View campaign pdf',
                        isDialog: true,
                        mobileonly:false,
                        hidden: true,
                    },
                    // @Note: If more subcategories are added later, adjust updateCampaignsPdfUrl()
                ],
            },
            {
                icon: 'mdi-chart-bar',
                title: 'Estatísticas',
                url: null,
                expanded: false,
                active: false,
                mobileonly:false,
                all_subcategories: [
                    {
                        title: 'Consumos',
                        url: '/statistics/consumptions',
                        active: false,
                        mobileonly:false,
                        permission: 'View consumptions',
                    },
                    {
                        title: 'Compras Mês',
                        url: '/statistics/monthly-purchases',
                        active: false,
                        mobileonly:false,
                        permission: 'View monthly purchases',
                    },
                    {
                        title: 'Top Compras',
                        url: '/statistics/top-purchases',
                        active: false,
                        mobileonly:false,
                        permission: 'View top purchases',
                    },
                ],
            },
            {
                icon: 'mdi-currency-eur',
                title: 'Financeiro',
                url: null,
                expanded: false,
                active: false,
                mobileonly:false,
                all_subcategories: [
                    {
                        title: 'Ficha de Cliente',
                        url: '/financial/branch-details',
                        active: false,
                        mobileonly:false,
                        permission: 'View client details',
                    },
                    {
                        title: 'Conta Corrente',
                        url: '/financial/checking-account',
                        active: false,
                        mobileonly:false,
                        permission: 'View financial details',
                    },
                    {
                        title: 'Rappel',
                        url: '/financial/rappel',
                        active: false,
                        mobileonly:false,
                        permission: 'View rappel',
                    },
                ],
            },
        ],

        corporateCategory: {
            icon: 'mdi-information-outline',
            title: 'Corporate',
            url: null,
            expanded: false,
            active: false,
            mobileonly:false,
            subcategories: [],
        },
    }),

    actions: {
        readIsCategoriesCardCollapsed() {
            const isCategoriesCardCollapsed = localStorage.getItem('isCategoriesCardCollapsed') ?? String(this.isCategoriesCardCollapsed);

            this.isCategoriesCardCollapsed = JSON.parse(isCategoriesCardCollapsed);
        },

        setIsCategoriesCardCollapsed(isCategoriesCardCollapsed) {
            this.isCategoriesCardCollapsed = isCategoriesCardCollapsed;

            localStorage.setItem('isCategoriesCardCollapsed', this.isCategoriesCardCollapsed);
        },

        getCorporateLinks(categories) {
            axios.get('/api/links/corporate').then((response) => {
                this.populateCorporateLinks(categories, response.data);
            });
        },

        updateCorporateLinks(corporateLinks) {
            this.populateCorporateLinks(this.categories, corporateLinks.data);
        },

        /*getCampaignsPdfStatus() {
            axios.get('/api/campaigns/pdf').then((response) => {
                this.updateCampaignsPdfUrl(!!response.data);
            });
        },*/

        updateCampaignsPdfUrl(urlExists) {
            this.categories.forEach((category) => {
                if (category.title == 'Campanhas') {
                    if (category.subcategories?.length) {
                        // Leaving this hardcoded to use length as we're targetting the "Informativo" entry (always the last one), and the alternative was not reactive.
                        category.subcategories[category.subcategories?.length - 1].hidden = urlExists ? false : true;
                    }
                }
            });
        },
        getCampaignsPdfStatus() {
            axios
                .get('/api/campaigns/pdf-status')
                .then((response) => {
                    if(response)
                       this.updateCampaignsPdfUrl(response.data.exists);
                })
                .catch(() => {
                    this.updateCampaignsPdfUrl(false);
                });
        },
        populateCorporateLinks(categories, corporateLinks) {
            categories.forEach((category) => {
                if (category.title == 'Corporate') {
                    category.subcategories = corporateLinks;

                    // Safeguard in case the user expands the Corporate list before this is ready
                    category.expanded = false;
                    category.active = false;
                }
            });
        },
    },

    getters: {
        categories: (state) => {
                const userStore = useUserStore();
                const branchStore = useBranchStore();
                const appStore = useAppStore();
                // The user might not have been fetched yet.
                if (userStore.user == null) return [];

                // The selected branch might not have been fetched yet.
                if (branchStore.branch == null) return [];

                let categories = state.all.filter((category) => {
                    // @Note: I want to see the categories that don't have a permission set.
                    //         OR
                    //        If they do have a permission, it needs to be active.
                    const isAllowedToSee = (c) => !('permission' in c) || userStore.hasPermissionTo(c.permission);

                    // Step 1. Special condition to check if the user is allowed to view some branch detail tabs
                    const isAllowedToViewClientDetails = (c) => {
                        if ('permission' in c) {
                            return !userStore.hasPermissionTo('View tax data') && !userStore.hasPermissionTo('View shipping data') && !userStore.hasPermissionTo('View business data') && !userStore.hasPermissionTo('View financial data') ? false : true;
                        }
                    };

                    if (!isAllowedToSee(category)) return false;

                    // If this category doesn't have subcategories, we're done.
                    if (!('all_subcategories' in category)) return true;

                    // Otherwise, we need to check if the subcategories themselves have permissions.
                    category.subcategories = category.all_subcategories.filter((subcategory) => isAllowedToSee(subcategory));

                    category.subcategories = category.subcategories.filter((subcategory) =>{

                        if(subcategory.mobileonly && appStore.isMobile || subcategory.mobileonly && appStore.isTablet){
                            return true
                        }else if(subcategory.mobileonly && !appStore.isMobile || subcategory.mobileonly && !appStore.isTablet){
                            return false
                        }else{
                            return true
                        }
                    });

                    // Step 2. Special condition to check if the user is allowed to view some branch detail tabs
                    category.subcategories = category.subcategories.filter((subcategory) => subcategory.permission !== 'View client details' || (subcategory.permission === 'View client details' && isAllowedToViewClientDetails(subcategory)));

                    // Check if the selected branch is allowed to view campaigns
                    if (category.title === 'Campanhas' && branchStore.branch.no_campaigns) return false;

                    // This check will prevent empty categories (it needs to happen after they've been filtered).
                    if (category.subcategories.length === 0 && category.url == null) return false;

                    return true;
                });

                if (!categories.find((category) => category.title == 'Corporate')) {
                    categories.push(state.corporateCategory);
                    state.getCorporateLinks(categories);
                }

                state.getCampaignsPdfStatus();

                return categories;
            },
    },
});
